import PanoramaCustomTableCell from './table-cell-content.vue'

export { PanoramaCustomTableCell }
